import createPocketBaseNewsLoader from './pocketbase';

const newsJA = {
  title: 'ニュース',
  tabs: ['プレスリリース', 'イベント', 'ソリューション', 'その他'],
  list: [],
  share: 'シェア',
  doneContent: {
    beforeWrap: 'このセミナーの受付は',
    afterWrap: '終了いたしました。',
    beforeLink: '今後開催されるセミナー情報などをご希望の方は、',
    link: 'こちらのフォーム',
    afterLink: 'からお申し込みください。',
    href: 'contact-us',
  },
  wxScan: 'WeChatでスキャンしてください',
  more: 'ニュース一覧',
  back: 'ニュース一覧',
};

const loadNewsJA = createPocketBaseNewsLoader({
  collection: 'news',
  lang: 'ja',
});

export default newsJA;
export { loadNewsJA };
